export default "__VITE_ASSET__5qP6WQuN__"